function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import localeKeys from '../../../../../../locales/keys';
var ShippingTooltipController = /*#__PURE__*/function () {
  function ShippingTooltipController() {
    _classCallCheck(this, ShippingTooltipController);
    this.localeKeys = localeKeys;
    this.tooltipContext = {};
  }
  return _createClass(ShippingTooltipController, [{
    key: "$onInit",
    value: function $onInit() {
      this.tooltipTemplate = require('./prices.description.tooltip.template.html');
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changeObj) {
      if (changeObj.items) {
        this.tooltipContext.items = changeObj.items.currentValue;
      }
      if (changeObj.currencyCode) {
        this.tooltipContext.currencyCode = changeObj.currencyCode.currentValue;
      }
      if (changeObj.brandableCurrencyName) {
        this.tooltipContext.brandableCurrencyName = changeObj.brandableCurrencyName.currentValue;
      }
    }
  }]);
}();
export default {
  bindings: {
    brandableCurrencyName: '<',
    currencyCode: '<',
    items: '<' // See CartTab in products.order.selector.helper.js
  },
  controller: ShippingTooltipController,
  template: require('./shipping.tooltip.html')
};